import { useState, useEffect } from "react";
import image1 from "../assets/bg1.jpg";
import image2 from "../assets/bg2.jpg";
import image3 from "../assets/bg3.jpg";
import image4 from "../assets/bg4.jpg";
import image5 from "../assets/bg5.jpg";

const images = [image1, image2, image3, image4, image5]; // Image array

function useRotatingImages(intervalTime = 5000) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length); // Loop through images
    }, intervalTime);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [intervalTime]);

  return images[currentIndex]; // Return the current image
}

export default useRotatingImages;
